import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { CategoryID } from '@sbt-web/network/types';
import css from './Placeholder.module.scss';
interface Props {
  categoryId: CategoryID;
}
const Placeholder: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    categoryId
  } = t0;
  const t1 = `${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/categories/${categoryId}.svg`;
  let t2;
  if ($[0] !== t1) {
    t2 = <figure className={css.placeholder}><img alt="" src={t1} width="96" height="96" decoding="async" /></figure>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default Placeholder;